import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CommonBaseComponent } from '../common-base.component';

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    RadioButtonModule,
    ReactiveFormsModule,
  ],
})
export class RadioButtonComponent extends CommonBaseComponent {
  @Input() defaultValue: any;
  @Input() name!: string;
  @Input() direction: 'row' | 'column' = 'row';

  constructor() {
    super();
  }
}
